import { Component } from "preact";
import PropTypes from "prop-types";
import withLocation from "../shared/hoc/withLocation";

class LocationRequester extends Component {
	render({children}) {
		return children;
	}

	static get propTypes() {
		return {
			children: PropTypes.any,
		}
	}
}

export default withLocation(LocationRequester, true, true);
